import React, { useEffect } from "react";
import { HashRouter } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { setUser, setSession } from "./Redux/Slices/authslice";
import { useDispatch, useSelector } from "react-redux";
import Navigation from "./Navigation.js";
import "remixicon/fonts/remixicon.css";
import { messaging } from "./Firebase/config.js";
import { onMessage } from "firebase/messaging";
import Widgets from "./Widgets/index.js";
import clinicService from "./Services/clinicService.js";
import authService from "./Services/authService.js";

const LoadingIndicator = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);
  return isLoading ? <Widgets.CircularLoader /> : null;
};

function App() {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const dispatch = useDispatch();

  if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
}

  useEffect(() => {
    const checkAuthentication = async () => {
      const userFromLocalStorage = JSON.parse(localStorage.getItem("user"));
      const sessionFromLocalStorage = JSON.parse(localStorage.getItem("session"));

      if (userFromLocalStorage && sessionFromLocalStorage) {
        dispatch(setUser(userFromLocalStorage));
        dispatch(setSession(sessionFromLocalStorage));
      }
    };

    checkAuthentication();
  }, [dispatch]);

  useEffect(() => {
    const clearExpiredSession = () => {
      const storedSession = localStorage.getItem("session");
      if (storedSession) {
        const sessionData = JSON.parse(storedSession);
        if (sessionData.expiresAt && new Date().getTime() > sessionData.expiresAt) {
          localStorage.removeItem("session");
          localStorage.removeItem("user");
        }
      }
    };
    clearExpiredSession();
  }, []);

  return (
    <div>
      <Toaster toastOptions={{ duration: 4000, position: "bottom-center" }} containerStyle={{ zIndex: 99999 }} />
      <div className="loading-app-container">
        <LoadingIndicator />
      </div>
      <HashRouter basename="/">
        <Navigation />
      </HashRouter>
    </div>
  );

  function LoginRedirect() {
    // return isAuthenticated ? <Navigate to="/home" /> : <LoginPage />;
  }
}

export default App;
